import styled from '@emotion/styled'
import React from 'react'
import { VoiceChat } from '../../firebase/firestore/VoiceChats'
import { Icon, IconifyIcon } from '@iconify/react'

const nintendoSwitch = {
  body: '<path d="M95.9 33.5c-44.6 8-80.5 41-91.8 84.4C0 133.6-.3 142.8.2 264.4C.4 376 .5 378.6 2.4 387.3c10.3 46.5 43.3 79.6 90.3 90.5c6.1 1.4 13.9 1.7 64.1 1.9c51.9.4 57.3.3 58.7-1.1c1.4-1.4 1.5-19.3 1.5-222.2c0-150.5-.3-221.3-.9-222.6c-.9-1.7-2.5-1.8-56.9-1.7c-44.2.1-57.5.4-63.3 1.4zm83.9 222.6V444l-37.8-.5c-34.8-.4-38.5-.6-45.5-2.3c-29.9-7.7-52-30.7-58.3-60.7c-2-9.4-2-240.1-.1-249.3c5.6-26.1 23.7-47.7 48-57.4c12.2-4.9 17.9-5.5 57.6-5.6l35.9-.1v188zm-75.9-131.2c-5.8 1.1-14.7 5.6-19.5 9.7c-9.7 8.4-14.6 20.4-13.8 34.5c.4 7.3.8 9.3 3.8 15.2c4.4 9 10.9 15.6 19.9 20c6.2 3.1 7.8 3.4 15.9 3.7c7.3.3 9.9 0 14.8-1.7c20.1-6.8 32.3-26.3 28.8-46.4c-3.9-23.7-26.6-39.7-49.9-35zm158.2-92.3c-.4.3-.6 100.8-.6 223.5c0 202.3.1 222.8 1.5 223.4c2.5.9 74.5.6 83.4-.4c37.7-4.3 71-27.2 89-61.2c2.3-4.4 5.4-11.7 7-16.2c5.8-17.4 5.7-12.8 5.7-146.1c0-106.4-.2-122.3-1.5-129c-9.2-48.3-46.1-84.8-94.5-93.1c-6.5-1.1-16.5-1.4-48.8-1.4c-22.4-.1-40.9.2-41.2.5zm99.1 202.1c14.5 3.8 26.3 14.8 31.2 28.9c3.1 8.7 3 21.5-.1 29.5c-5.7 14.7-16.8 25-31.1 28.8c-23.2 6-47.9-8-54.6-31c-2-7-1.9-18.9.4-26.2c6.9-22.7 31-36.1 54.2-30z" fill="currentColor"/>',
  width: 448,
  height: 512,
}

const playStation = {
  body: '<path d="M570.9 372.3c-11.3 14.2-38.8 24.3-38.8 24.3L327 470.2v-54.3l150.9-53.8c17.1-6.1 19.8-14.8 5.8-19.4c-13.9-4.6-39.1-3.3-56.2 2.9L327 381.1v-56.4c23.2-7.8 47.1-13.6 75.7-16.8c40.9-4.5 90.9.6 130.2 15.5c44.2 14 49.2 34.7 38 48.9zm-224.4-92.5v-139c0-16.3-3-31.3-18.3-35.6c-11.7-3.8-19 7.1-19 23.4v347.9l-93.8-29.8V32c39.9 7.4 98 24.9 129.2 35.4C424.1 94.7 451 128.7 451 205.2c0 74.5-46 102.8-104.5 74.6zM43.2 410.2c-45.4-12.8-53-39.5-32.3-54.8c19.1-14.2 51.7-24.9 51.7-24.9l134.5-47.8v54.5l-96.8 34.6c-17.1 6.1-19.7 14.8-5.8 19.4c13.9 4.6 39.1 3.3 56.2-2.9l46.4-16.9v48.8c-51.6 9.3-101.4 7.3-153.9-10z" fill="currentColor"/>',
  width: 576,
  height: 512,
}

const skype = {
  body: '<path d="M424.7 299.8c2.9-14 4.7-28.9 4.7-43.8c0-113.5-91.9-205.3-205.3-205.3c-14.9 0-29.7 1.7-43.8 4.7C161.3 40.7 137.7 32 112 32C50.2 32 0 82.2 0 144c0 25.7 8.7 49.3 23.3 68.2c-2.9 14-4.7 28.9-4.7 43.8c0 113.5 91.9 205.3 205.3 205.3c14.9 0 29.7-1.7 43.8-4.7c19 14.6 42.6 23.3 68.2 23.3c61.8 0 112-50.2 112-112c.1-25.6-8.6-49.2-23.2-68.1zm-194.6 91.5c-65.6 0-120.5-29.2-120.5-65c0-16 9-30.6 29.5-30.6c31.2 0 34.1 44.9 88.1 44.9c25.7 0 42.3-11.4 42.3-26.3c0-18.7-16-21.6-42-28c-62.5-15.4-117.8-22-117.8-87.2c0-59.2 58.6-81.1 109.1-81.1c55.1 0 110.8 21.9 110.8 55.4c0 16.9-11.4 31.8-30.3 31.8c-28.3 0-29.2-33.5-75-33.5c-25.7 0-42 7-42 22.5c0 19.8 20.8 21.8 69.1 33c41.4 9.3 90.7 26.8 90.7 77.6c0 59.1-57.1 86.5-112 86.5z" fill="currentColor"/>',
  width: 448,
  height: 512,
}

const discord = {
  body: '<path d="M297.216 243.2c0 15.616-11.52 28.416-26.112 28.416c-14.336 0-26.112-12.8-26.112-28.416s11.52-28.416 26.112-28.416c14.592 0 26.112 12.8 26.112 28.416zm-119.552-28.416c-14.592 0-26.112 12.8-26.112 28.416s11.776 28.416 26.112 28.416c14.592 0 26.112-12.8 26.112-28.416c.256-15.616-11.52-28.416-26.112-28.416zM448 52.736V512c-64.494-56.994-43.868-38.128-118.784-107.776l13.568 47.36H52.48C23.552 451.584 0 428.032 0 398.848V52.736C0 23.552 23.552 0 52.48 0h343.04C424.448 0 448 23.552 448 52.736zm-72.96 242.688c0-82.432-36.864-149.248-36.864-149.248c-36.864-27.648-71.936-26.88-71.936-26.88l-3.584 4.096c43.52 13.312 63.744 32.512 63.744 32.512c-60.811-33.329-132.244-33.335-191.232-7.424c-9.472 4.352-15.104 7.424-15.104 7.424s21.248-20.224 67.328-33.536l-2.56-3.072s-35.072-.768-71.936 26.88c0 0-36.864 66.816-36.864 149.248c0 0 21.504 37.12 78.08 38.912c0 0 9.472-11.52 17.152-21.248c-32.512-9.728-44.8-30.208-44.8-30.208c3.766 2.636 9.976 6.053 10.496 6.4c43.21 24.198 104.588 32.126 159.744 8.96c8.96-3.328 18.944-8.192 29.44-15.104c0 0-12.8 20.992-46.336 30.464c7.68 9.728 16.896 20.736 16.896 20.736c56.576-1.792 78.336-38.912 78.336-38.912z" fill="currentColor"/>',
  width: 448,
  height: 512,
}

const line = {
  body: '<path d="M272.1 204.2v71.1c0 1.8-1.4 3.2-3.2 3.2h-11.4c-1.1 0-2.1-.6-2.6-1.3l-32.6-44v42.2c0 1.8-1.4 3.2-3.2 3.2h-11.4c-1.8 0-3.2-1.4-3.2-3.2v-71.1c0-1.8 1.4-3.2 3.2-3.2H219c1 0 2.1.5 2.6 1.4l32.6 44v-42.2c0-1.8 1.4-3.2 3.2-3.2h11.4c1.8-.1 3.3 1.4 3.3 3.1zm-82-3.2h-11.4c-1.8 0-3.2 1.4-3.2 3.2v71.1c0 1.8 1.4 3.2 3.2 3.2h11.4c1.8 0 3.2-1.4 3.2-3.2v-71.1c0-1.7-1.4-3.2-3.2-3.2zm-27.5 59.6h-31.1v-56.4c0-1.8-1.4-3.2-3.2-3.2h-11.4c-1.8 0-3.2 1.4-3.2 3.2v71.1c0 .9.3 1.6.9 2.2c.6.5 1.3.9 2.2.9h45.7c1.8 0 3.2-1.4 3.2-3.2v-11.4c0-1.7-1.4-3.2-3.1-3.2zM332.1 201h-45.7c-1.7 0-3.2 1.4-3.2 3.2v71.1c0 1.7 1.4 3.2 3.2 3.2h45.7c1.8 0 3.2-1.4 3.2-3.2v-11.4c0-1.8-1.4-3.2-3.2-3.2H301v-12h31.1c1.8 0 3.2-1.4 3.2-3.2V234c0-1.8-1.4-3.2-3.2-3.2H301v-12h31.1c1.8 0 3.2-1.4 3.2-3.2v-11.4c-.1-1.7-1.5-3.2-3.2-3.2zM448 113.7V399c-.1 44.8-36.8 81.1-81.7 81H81c-44.8-.1-81.1-36.9-81-81.7V113c.1-44.8 36.9-81.1 81.7-81H367c44.8.1 81.1 36.8 81 81.7zm-61.6 122.6c0-73-73.2-132.4-163.1-132.4c-89.9 0-163.1 59.4-163.1 132.4c0 65.4 58 120.2 136.4 130.6c19.1 4.1 16.9 11.1 12.6 36.8c-.7 4.1-3.3 16.1 14.1 8.8c17.4-7.3 93.9-55.3 128.2-94.7c23.6-26 34.9-52.3 34.9-81.5z" fill="currentColor"/>',
  width: 448,
  height: 512,
}

const mobile = {
  body: '<path d="M744 62H280c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h464c35.3 0 64-28.7 64-64V126c0-35.3-28.7-64-64-64zm-8 824H288V134h448v752zM472 784a40 40 0 1 0 80 0a40 40 0 1 0-80 0z" fill="currentColor"/>',
  width: 1024,
  height: 1024,
}

const parallel = {
  body: '<path d="M744 62H280c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h464c35.3 0 64-28.7 64-64V126c0-35.3-28.7-64-64-64zm-8 824H288V134h448v752zM472 784a40 40 0 1 0 80 0a40 40 0 1 0-80 0z" fill="currentColor"/>',
  width: 1024,
  height: 1024,
}

const headset = {
  body: '<path d="M192 208c0-17.67-14.33-32-32-32h-16c-35.35 0-64 28.65-64 64v48c0 35.35 28.65 64 64 64h16c17.67 0 32-14.33 32-32V208zm176 144c35.35 0 64-28.65 64-64v-48c0-35.35-28.65-64-64-64h-16c-17.67 0-32 14.33-32 32v112c0 17.67 14.33 32 32 32h16zM256 0C113.18 0 4.58 118.83 0 256v16c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-16c0-114.69 93.31-208 208-208s208 93.31 208 208h-.12c.08 2.43.12 165.72.12 165.72c0 23.35-18.93 42.28-42.28 42.28H320c0-26.51-21.49-48-48-48h-32c-26.51 0-48 21.49-48 48s21.49 48 48 48h181.72c49.86 0 90.28-40.42 90.28-90.28V256C507.42 118.83 398.82 0 256 0z" fill="currentColor"/>',
  width: 512,
  height: 512,
}

const caseBy = {
  body: '<defs/><path d="M945 412H689c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h256c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM811 548H689c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h122c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM477.3 322.5H434c-6.2 0-11.2 5-11.2 11.2v248c0 3.6 1.7 6.9 4.6 9l148.9 108.6c5 3.6 12 2.6 15.6-2.4l25.7-35.1v-.1c3.6-5 2.5-12-2.5-15.6l-126.7-91.6V333.7c.1-6.2-5-11.2-11.1-11.2z" fill="currentColor"/><path d="M804.8 673.9H747c-5.6 0-10.9 2.9-13.9 7.7c-12.7 20.1-27.5 38.7-44.5 55.7c-29.3 29.3-63.4 52.3-101.3 68.3c-39.3 16.6-81 25-124 25c-43.1 0-84.8-8.4-124-25c-37.9-16-72-39-101.3-68.3s-52.3-63.4-68.3-101.3c-16.6-39.2-25-80.9-25-124c0-43.1 8.4-84.7 25-124c16-37.9 39-72 68.3-101.3c29.3-29.3 63.4-52.3 101.3-68.3c39.2-16.6 81-25 124-25c43.1 0 84.8 8.4 124 25c37.9 16 72 39 101.3 68.3c17 17 31.8 35.6 44.5 55.7c3 4.8 8.3 7.7 13.9 7.7h57.8c6.9 0 11.3-7.2 8.2-13.3c-65.2-129.7-197.4-214-345-215.7c-216.1-2.7-395.6 174.2-396 390.1C71.6 727.5 246.9 903 463.2 903c149.5 0 283.9-84.6 349.8-215.8c3.1-6.1-1.4-13.3-8.2-13.3z" fill="currentColor"/>',
  width: 1024,
  height: 1024,
}

const times = {
  body: '<path d="M256 8C119 8 8 119 8 256s111 248 248 248s248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65l-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7l65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z" fill="currentColor"/>',
  width: 512,
  height: 512,
}

const mapValueToContent: Record<
  VoiceChat,
  { color: string; icon: IconifyIcon }
> = {
  0: {
    color: '#25A0DE',
    icon: skype,
  },
  1: {
    color: '#42CB24',
    icon: line,
  },
  2: {
    color: '#033DA0',
    icon: playStation,
  },
  3: {
    color: '#738BD7',
    icon: discord,
  },
  4: {
    color: '#FF0021',
    icon: times,
  },
  5: {
    color: '#F95849',
    icon: nintendoSwitch,
  },
  6: {
    color: '#25A0DE',
    icon: mobile,
  },
  7: {
    color: '#DE412D',
    icon: parallel,
  },
  8: {
    color: '#F6E10D',
    icon: mobile,
  },
  97: {
    color: '#ccc',
    icon: headset,
  },
  98: {
    color: '#FF0021',
    icon: times,
  },
  99: {
    color: '#ccc',
    icon: headset,
  },
  100: {
    color: '#F98849',
    icon: caseBy,
  },
}

type Props = {
  onChange: (selectedIndex: Array<VoiceChat>) => void // 0Skype 1LINE 2PlayStation 3Discord 4kikisen
  value: Array<VoiceChat>
  activeValue: Array<VoiceChat>
}

export const VoiceChatSelector: React.FC<Props> = ({
  onChange,
  value,
  activeValue,
}) => {
  return (
    <Container>
      {activeValue.map((v) => {
        return (
          <Item
            key={v}
            onClick={() => {
              const newVal = value.includes(v)
                ? value.filter((c) => c !== v)
                : value.concat(v)
              onChange(newVal)
            }}
            selected={value.includes(v)}
          >
            <Icon
              icon={mapValueToContent[v].icon}
              color={mapValueToContent[v].color}
            />
          </Item>
        )
      })}
    </Container>
  )
}

type SingleProps = {
  onChange: (selectedIndex: VoiceChat) => void // 0Skype 1LINE 2PlayStation 3Discord 4kikisen
  value: VoiceChat
  activeValue: Array<VoiceChat>
}

export const VoiceChatSingleSelector: React.FC<SingleProps> = ({
  onChange,
  value,
  activeValue,
}) => {
  return (
    <Container>
      {activeValue.map((v) => {
        return (
          <Item
            key={v}
            onClick={() => {
              onChange(v)
            }}
            selected={value === v}
          >
            <Icon
              icon={mapValueToContent[v].icon}
              color={mapValueToContent[v].color}
              width={24}
            />
          </Item>
        )
      })}
    </Container>
  )
}

const Container = styled.div`
  width: 100%;
  border: 3px solid #b7d7ea;
  background-color: #fff;
  border-radius: 4px;
  width: 100%;
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const Item = styled.div<{ selected: boolean }>`
  width: 44px;
  height: 44px;
  border: 4px solid ${({ selected }) => (selected ? '#b7d7ea' : 'transparent')};
  background-color: transparent;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
`
